export const phases = {
  spawning: 'spawning',
  descending: 'descending',
  locking: 'locking',
  clearing: 'clearing',
  gameOver: 'gameOver',
  starting: 'starting',
  pending: 'pending',
  paused: 'paused',
  resuming: 'resuming'
};
